import { FC } from 'react';
import { Box, TextField } from '@mui/material';
import StyledLabel from 'modules/map/components/daily-dish/components/utils/StyledLabel';
import { FIELD_WIDTHS } from 'modules/map/components/daily-dish/constants';

interface NumberFieldWithLimitsProps {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  width?: string;
}

/**
 * Reusable number input field with validation
 */
export const NumberFieldWithLimits: FC<NumberFieldWithLimitsProps> = ({
  label,
  value,
  min,
  max,
  onChange,
  width = FIELD_WIDTHS.HALF,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseInt(e.target.value);
    if (!Number.isNaN(val) && val >= min && val <= max) {
      onChange(val);
    }
  };

  return (
    <Box sx={{ width }}>
      <StyledLabel label={label} />
      <TextField
        type="number"
        fullWidth
        size="small"
        value={value}
        inputProps={{ min, max }}
        onChange={handleChange}
      />
    </Box>
  );
};
